// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qg-graph-node {
    border: 1px solid transparent;
    border-radius: .8em;
    padding: .3em .5em;
    margin: -.3em -.5em;
    transition-property: border-color, background-color;
    transition-duration: 0.2s;
}
.qg-graph-node.qg-no-props {
    cursor: default;
}
.qg-graph-node.qg-collapsed:hover,
.qg-graph-node.qg-expanded {
    cursor: pointer;
    background: white;
    border-color: hsl(0,0%, 80%);
    box-shadow: 1px 2px 5px hsl(0,0%,90%);
}

.query-graph .react-flow__handle.qg-subtree-handle {
    font-size: .7em;
    width: 1em;
    height: 1em;
    bottom: -.8em;
    line-height: 1em;
    text-align: center;
    border-radius: 0.5em;
    background: hsl(0,0%,85%);
    cursor: pointer;
    pointer-events: all;
    transition-property: background-color;
    transition-duration: 0.2s;
}

.query-graph .react-flow__handle.qg-subtree-handle.qg-collapsed {
    opacity: 0;
}
.query-graph .react-flow__node-querynode:hover .react-flow__handle.qg-subtree-handle {
    opacity: 1;
}

.query-graph .react-flow__handle.qg-subtree-handle:hover {
    background: hsl(0,0%,70%);
}

.qg-graph-node-head {
    /* We don't want the node to automatically stretch/shrink with its container
     * because that would trigger the \`ResizeObserver\` to  often and would cause too
     * many layout recomputations.*/
    width: max-content;
    margin: auto;
    text-align: center;
}

.qg-graph-node-label {
    /*
     * Clip the label at some length; long labels can become quite unreadable
     */
    max-width: 10em;
    text-overflow: ellipsis;
    overflow: hidden;
    /*
     * We set up everything such that we can draw a nice background for the label.
     * If the node label should be highlighted, a \`background-color\` is set from React.
     */
    border-radius: .4em;
    padding: 0 .15em;
}

.qg-graph-node-body-wrapper {
    max-width: 0;
    max-height: 0;
    overflow: hidden;
    transition-property: max-width, max-height;
    transition-duration: .2s;
}
.qg-graph-node.qg-expanded .qg-graph-node-body-wrapper {
    max-width: 30em;
    max-height: 20em;
}
.qg-graph-node-body {
    width: max-content;
    height: max-content;
    overflow: auto;
    max-width: 30em;
    max-height: 20em;
}

.qg-prop-name {
    color: hsl(0, 0%, 50%);
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.qg-prop-value {
    -webkit-user-select: text;
    -ms-user-select: text;
    user-select: text;
}`, "",{"version":3,"sources":["webpack://./../query-graphs/lib/ui/QueryNode.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mDAAmD;IACnD,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;;IAEI,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;;mCAE+B;IAC/B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;;MAEE;IACF,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB;;;MAGE;IACF,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,0CAA0C;IAC1C,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;AACrB","sourcesContent":[".qg-graph-node {\n    border: 1px solid transparent;\n    border-radius: .8em;\n    padding: .3em .5em;\n    margin: -.3em -.5em;\n    transition-property: border-color, background-color;\n    transition-duration: 0.2s;\n}\n.qg-graph-node.qg-no-props {\n    cursor: default;\n}\n.qg-graph-node.qg-collapsed:hover,\n.qg-graph-node.qg-expanded {\n    cursor: pointer;\n    background: white;\n    border-color: hsl(0,0%, 80%);\n    box-shadow: 1px 2px 5px hsl(0,0%,90%);\n}\n\n.query-graph .react-flow__handle.qg-subtree-handle {\n    font-size: .7em;\n    width: 1em;\n    height: 1em;\n    bottom: -.8em;\n    line-height: 1em;\n    text-align: center;\n    border-radius: 0.5em;\n    background: hsl(0,0%,85%);\n    cursor: pointer;\n    pointer-events: all;\n    transition-property: background-color;\n    transition-duration: 0.2s;\n}\n\n.query-graph .react-flow__handle.qg-subtree-handle.qg-collapsed {\n    opacity: 0;\n}\n.query-graph .react-flow__node-querynode:hover .react-flow__handle.qg-subtree-handle {\n    opacity: 1;\n}\n\n.query-graph .react-flow__handle.qg-subtree-handle:hover {\n    background: hsl(0,0%,70%);\n}\n\n.qg-graph-node-head {\n    /* We don't want the node to automatically stretch/shrink with its container\n     * because that would trigger the `ResizeObserver` to  often and would cause too\n     * many layout recomputations.*/\n    width: max-content;\n    margin: auto;\n    text-align: center;\n}\n\n.qg-graph-node-label {\n    /*\n     * Clip the label at some length; long labels can become quite unreadable\n     */\n    max-width: 10em;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    /*\n     * We set up everything such that we can draw a nice background for the label.\n     * If the node label should be highlighted, a `background-color` is set from React.\n     */\n    border-radius: .4em;\n    padding: 0 .15em;\n}\n\n.qg-graph-node-body-wrapper {\n    max-width: 0;\n    max-height: 0;\n    overflow: hidden;\n    transition-property: max-width, max-height;\n    transition-duration: .2s;\n}\n.qg-graph-node.qg-expanded .qg-graph-node-body-wrapper {\n    max-width: 30em;\n    max-height: 20em;\n}\n.qg-graph-node-body {\n    width: max-content;\n    height: max-content;\n    overflow: auto;\n    max-width: 30em;\n    max-height: 20em;\n}\n\n.qg-prop-name {\n    color: hsl(0, 0%, 50%);\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.qg-prop-value {\n    -webkit-user-select: text;\n    -ms-user-select: text;\n    user-select: text;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
